import SiteConfig from '@/services/SiteConfig'

const DAY_BY_MILLISECOND = 24 * 60 * 60 * 1000

class CookieHelper {
  constructor() {
    if (CookieHelper.Singleton) return

    CookieHelper.Singleton = this
  }

  // The server has no cookie jar: reads answer "not set" and writes are
  // dropped. Request-cookie forwarding is a later SSR ticket (VIP-12037).
  setCookie(name, value, expirationDays, domain = SiteConfig.domain) {
    if (import.meta.env.SSR) return
    document.cookie = `${name}=${value};${_getExpires(expirationDays * DAY_BY_MILLISECOND)}';domain=${_prepareDomain(domain)};path=/;`
  }

  getCookie(name) {
    if (import.meta.env.SSR) return ''
    const cookieName = name + '='
    const decodedCookie = decodeURIComponent(document.cookie)
    const ca = decodedCookie.split(';')
    for (const char of ca) {
      let c = char
      while (c.startsWith(' ')) {
        c = c.substring(1)
      }
      if (c.startsWith(cookieName)) {
        return c.substring(cookieName.length, c.length)
      }
    }
    return ''
  }

  invalidate(name, domain = SiteConfig.domain) {
    if (import.meta.env.SSR) return
    document.cookie = `${name}=;expires=01 Jan 1970 00:00:00 GMT;domain=${_prepareDomain(domain)};path=/;`
  }

  isSet(name, domain = SiteConfig.domain) {
    if (import.meta.env.SSR) return false
    if (this.getCookie(name)) return true

    // httpOnly cookie
    document.cookie =
      name + `=val;domain=${_prepareDomain(domain)};path=/;${_getExpires(1000)}`
    // httOnly cookie cannot be set again, therefore we have to check for non-existent cookie which we tried to set
    return (
      !document.cookie.includes(name + '=') && location.hostname !== 'localhost'
    )
  }
}

const _getExpires = (exp) => {
  const d = new Date()
  d.setTime(d.getTime() + exp)

  return `expires=${d.toUTCString()}`
}

const _prepareDomain = (domain) => {
  if (!domain) return
  return domain.replace('www.', '.')
}

export default new CookieHelper()
